export const PLACES_APP_NAME = 'Microsoft Places';
export const PLACES_BRANDING_NAME = 'Places';
